import { render, staticRenderFns } from "./ResetPasswordSuccess.vue?vue&type=template&id=4d3dedec&scoped=true&"
import script from "./ResetPasswordSuccess.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordSuccess.vue?vue&type=style&index=0&id=4d3dedec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3dedec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
